module.exports = __webpack_public_path__ + "img/unsupported.925dd0d2.svg";